// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Non bloquant : carte d'angle (bas-droite), sans backdrop, slide depuis la droite. */
.popup-profil-toast {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 9999;
  width: min(420px, calc(100vw - 3rem));
  animation: popup-profil-slide-in 0.3s ease-out;
}

@keyframes popup-profil-slide-in {
  from {
    transform: translateX(120%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.popup-profil-modal {
  position: relative;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 1.8rem 2rem 1.6rem;
  width: 100%;
  box-shadow: 0 16px 44px rgba(0, 0, 0, 0.22);
  font-size: clamp(1.1rem, 1.8vw, 1.3rem);
}

.popup-profil-close {
  position: absolute;
  top: 0.9rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: clamp(1.7rem, 3vw, 2.2rem);
  line-height: 1;
  color: #9ca3af;
  cursor: pointer;
}

.popup-profil-close:hover {
  color: #374151;
}

.popup-profil-title {
  font-size: clamp(1.5rem, 2.8vw, 2rem);
  font-weight: 700;
  color: #595959;
  margin: 0 0 0.75rem 0;
}

.popup-profil-body {
  font-size: clamp(1.1rem, 1.8vw, 1.3rem);
  color: #374151;
  line-height: 1.6;
  margin: 0 0 1.5rem 0;
}

.popup-profil-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.popup-profil-cta {
  padding: 0.6rem 1.4rem;
  background: #f97316;
  color: #fff;
  border: none;
  border-radius: 0.4rem;
  font-size: clamp(1rem, 1.6vw, 1.2rem);
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.popup-profil-cta:hover {
  background: #ea6c0a;
}

.popup-profil-dismiss {
  padding: 0.6rem 1.2rem;
  background: none;
  color: #6b7280;
  border: 1px solid #d1d5db;
  border-radius: 0.4rem;
  font-size: clamp(1rem, 1.6vw, 1.2rem);
  cursor: pointer;
}

.popup-profil-dismiss:hover {
  background: #f9fafb;
}
`, "",{"version":3,"sources":["webpack://./src/composants/PopupProfilIncomplet/PopupProfilIncomplet.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Non bloquant : carte d'angle (bas-droite), sans backdrop, slide depuis la droite. */\n.popup-profil-toast {\n  position: fixed;\n  bottom: 1.5rem;\n  right: 1.5rem;\n  z-index: 9999;\n  width: min(420px, calc(100vw - 3rem));\n  animation: popup-profil-slide-in 0.3s ease-out;\n}\n\n@keyframes popup-profil-slide-in {\n  from {\n    transform: translateX(120%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.popup-profil-modal {\n  position: relative;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.75rem;\n  padding: 1.8rem 2rem 1.6rem;\n  width: 100%;\n  box-shadow: 0 16px 44px rgba(0, 0, 0, 0.22);\n  font-size: clamp(1.1rem, 1.8vw, 1.3rem);\n}\n\n.popup-profil-close {\n  position: absolute;\n  top: 0.9rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  font-size: clamp(1.7rem, 3vw, 2.2rem);\n  line-height: 1;\n  color: #9ca3af;\n  cursor: pointer;\n}\n\n.popup-profil-close:hover {\n  color: #374151;\n}\n\n.popup-profil-title {\n  font-size: clamp(1.5rem, 2.8vw, 2rem);\n  font-weight: 700;\n  color: #595959;\n  margin: 0 0 0.75rem 0;\n}\n\n.popup-profil-body {\n  font-size: clamp(1.1rem, 1.8vw, 1.3rem);\n  color: #374151;\n  line-height: 1.6;\n  margin: 0 0 1.5rem 0;\n}\n\n.popup-profil-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.popup-profil-cta {\n  padding: 0.6rem 1.4rem;\n  background: #f97316;\n  color: #fff;\n  border: none;\n  border-radius: 0.4rem;\n  font-size: clamp(1rem, 1.6vw, 1.2rem);\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.popup-profil-cta:hover {\n  background: #ea6c0a;\n}\n\n.popup-profil-dismiss {\n  padding: 0.6rem 1.2rem;\n  background: none;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n  border-radius: 0.4rem;\n  font-size: clamp(1rem, 1.6vw, 1.2rem);\n  cursor: pointer;\n}\n\n.popup-profil-dismiss:hover {\n  background: #f9fafb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
